export default __webpack_public_path__ + "static/media/house-wife.2041d783.jpg";